import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { FtoReportRetrievalResultReportModel } from '../retrieval-result-report-model';
import type { RetrievalResultReportState } from '../../types';
import { AbstractModel } from '@patsnap/tahiti-core';

function createInitialRetrievalResultReportState(): RetrievalResultReportState {
    return {
        title: '',
        userInput: '',
        techEssential: '',
        techFeatures: [],
        techFeaturesWithComparedPats: [],
        noveltyReview: [],
        creativityReview: [],
        threshold: 0,
        creator: '',
        generatedTime: 0,
        searchQty: 0,
        comparativeQty: 0,
        nearestQty: 0,
        secondaryApproachQty: 0,
        searchScope: {
            en: '',
            zh: '',
            jp: '',
        },
        header: {
            en: '',
            zh: '',
            jp: '',
        },
        /**
         * 用户选择的专利受理局
         */
        country: [],
        legalStatus: [],
        includeCompany: [],
        excludeCompany: [],
        apdStart: null,
        apdEnd: null,
    };
}

@injectable()
export class FtoReportRetrievalResultReportModelImpl extends AbstractModel<RetrievalResultReportState> implements FtoReportRetrievalResultReportModel {
    protected _modelData: RetrievalResultReportState = createInitialRetrievalResultReportState();

    dispose(): void {
        this.update(() => createInitialRetrievalResultReportState());
    }
}
